import { notify } from '@yembo/yemblocks-core';
import type { SessionEnd } from 'src/queries/apiStatus';
import { removeAuth } from './AuthModule';

const SESSION_END_MESSAGES: Record<SessionEnd, string> = {
  expired: 'Your session expired, sign in again',
  // Revoked from another device, signed out, or ended by a password reset.
  unauthorized: 'Your session ended, sign in again',
};

/**
 * Sign the person out on this device after the API refused their session.
 * Clearing the credentials is what sends them to the login screen:
 * PrivateRoute listens for the auth change and redirects, keeping the page
 * they were on as `nextPage`.
 *
 * Several requests in flight usually fail together, so only the first one to
 * arrive (the one that still finds a token) tells the person why.
 */
export const endSession = (reason: SessionEnd) => {
  const hadSession = !!localStorage.getItem('accessToken');

  localStorage.clear();
  removeAuth();

  if (hadSession) notify.info(SESSION_END_MESSAGES[reason]);
};
